/**
 * Short "plum" chime for a new meeting note. Synthesized with Web Audio so
 * there's no asset to bundle and it works offline. Best-effort — silently does
 * nothing if the AudioContext can't start (e.g. no prior user gesture).
 */
export function playNoteChime(): void {
  try {
    const AC =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!AC) return;
    const ctx = new AC();
    const now = ctx.currentTime;
    const tone = (freq: number, start: number, dur: number) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + start);
      gain.gain.exponentialRampToValueAtTime(0.18, now + start + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + start + dur);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + start);
      osc.stop(now + start + dur);
    };
    tone(659.25, 0, 0.14); // E5 — "plu"
    tone(880.0, 0.09, 0.18); // A5 — "m"
    window.setTimeout(() => void ctx.close().catch(() => {}), 600);
  } catch {
    /* audio unavailable — no chime */
  }
}
